<template>
  <div
    @click="$emit('open-chat')"
    class="absolute bottom-0 right-0 p-3 z-50"
  >
    <img
      :src="launcherUrl"
      alt="Start Chat"
      class="w-[150px] [@media(min-width:768px)]:w-[200px]"
    />
    <!-- Unread badge: red circle at top-right when there are unread messages -->
    <span
      v-if="notif.unreadCount > 0"
      class="absolute top-[10px] right-[10px] min-w-[20px] h-[10px] p-[4px] flex items-center justify-center
        rounded-full bg-[#F61212] text-[#ffffff] text-xs font-bold z-50"
      aria-label="Mensajes sin leer"
    >
      {{ notif.unreadCount > 99 ? '99+' : notif.unreadCount }}
    </span>
  </div>
</template>


<script>
import { useNotifications } from '../composables/useNotifications'

export default {
    name: 'ChatLauncher',
    data() {
      const { state } = useNotifications()
      return {
        notif: state,
        launcherUrl: require(`@/assets/${process.env.VUE_APP_LAUNCHER}`)
      }
    },
}
</script>
